import apiClient from './client';

// ── API Tokens (PAT) ───────────────────────────────────────────────────────────
// Note: apiClient here is the default export from client.js — which is the
// configured axios instance (baseURL = /api, Authorization header injected).

export const apiTokensAPI = {
  /** List all tokens for the current company */
  getAll: () => apiClient.get('/api-tokens'),

  /**
   * Create a new token.
   * @param {{ name: string, scope: string, expiresAt: string|null }} data
   * @returns {{ tokenId, token, prefix, name, scope, expiresAt, createdAt }}
   *   `token` is the raw value — shown only once, save immediately.
   */
  create: (data) => apiClient.post('/api-tokens', data),

  /**
   * Soft-revoke a token (keeps audit record, cannot be reactivated).
   * @param {string} tokenId
   */
  revoke: (tokenId) => apiClient.post(`/api-tokens/${tokenId}/revoke`),

  /**
   * Permanently delete a token (must be revoked first).
   * @param {string} tokenId
   */
  delete: (tokenId) => apiClient.delete(`/api-tokens/${tokenId}`),
};

export default apiTokensAPI;
